/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { UserDetail } from './user-detail';
import { mapDispatchToProps, mapStateToProps } from './user-detail-utils';
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
